module.exports = __webpack_public_path__ + "img/banner1.bc017441.jpg";